<script setup lang="ts">
import { type V1GetOptions } from "@gasparigit/omnia-sdk";
import Calendar from "~/components/icons/Calendar.vue";
import Filter from "~/components/icons/Filter.vue";
import { processError } from "~/lib/utils/errors";
import { defineSeo } from "~/lib/utils/seo";

const route = useRoute();
const omniaSdk = useOmniaSdk();

const page = usePage();
const options = ref<V1GetOptions>({
  future: true,
  past: true,
  order_mode: (useRoute().query["order"] as "asc" | "desc") || "asc",
  from_date: useRoute().query["from"] ? new Date(useRoute().query["from"] as string) : new Date(),
  to_date: useRoute().query["to"] ? new Date(useRoute().query["to"] as string) : null,
});

const areasFilter = ref<string[]>();

const { data, refresh } = useAsyncData("scadenzario", async () => {
  try {
    return await omniaSdk.v1.contents.list({ areas: areasFilter.value }, "scadenzario", { pagination: "classic", page: page.value }, options.value);
  } catch (error) {
    processError(error);
  }
});

watch(options.value, (val) => {
  useRouter().push({ query: { ...useRoute().query, order: val.order_mode, from: val.from_date?.toISOString(), to: val.to_date?.toISOString() } });
  refresh();
});

defineSeo({ title: "Scadenzario" });
</script>

<template>
  <FrontBreadcrumHero :breadcrumbs="[{ title: 'Scadenzario' }]" title="Scadenzario" :search="true" :icon="Calendar" :search-filters="{ front_content_type: ['scadenzario'] }"></FrontBreadcrumHero>

  <div class="main-content">
    <FrontContentsList title="Scadenzario" :icon="Calendar" :link-config="{}" v-model:data="data" v-model:page="page" @update:page="refresh()" :show-areas="true">
      <template #side>
        <FrontPrimaryCard :icon="Filter" title="Filtra per data">
          <div class="mb-3">
            <FormField name="filter_date_from" v-slot="{ componentField }">
              <FormItem>
                <FormLabel>Dal</FormLabel>
                <DatePicker v-bind="componentField" v-model="options.from_date" :has-input="false" @update:model-value="refresh()"></DatePicker>
              </FormItem>
            </FormField>
          </div>
          <div>
            <FormField name="filter_date_to" v-slot="{ componentField }">
              <FormItem>
                <FormLabel>Al</FormLabel>
                <DatePicker v-bind="componentField" v-model="options.to_date" :has-input="false" @update:model-value="refresh()"></DatePicker>
              </FormItem>
            </FormField>
          </div>
        </FrontPrimaryCard>

        <FrontAreasFilter name="area" v-model="areasFilter" @update:model-value="refresh()" class="mb-5" />

        <FrontRadioGroupCard base-key="order" v-model="options.order_mode"></FrontRadioGroupCard>
      </template>
    </FrontContentsList>
  </div>
</template>
